// eslint-disable-next-line
import { injectable } from "inversify";
import { IShopifySettings } from "../../models/IntegrationsTypes";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import {WithOld} from "../../stores/types";

export interface IShopifySettingsService {
    getShopifySettings: () => Promise<IShopifySettings>,
}

export interface ICustomPortalUrlValidationResponse {
    is_valid: boolean;
    message?: string;
}

@injectable()
class ShopifySettingsService implements IShopifySettingsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getShopifySettings(): Promise<IShopifySettings> {
        const res = await this.httpService.get<IApiResponse<IShopifySettings>>(`/rms-api/integrations/shopify-settings`);
        return res.payload;
    };
    
    async saveShopifySettings(data: WithOld<IShopifySettings>): Promise<IShopifySettings> {
        const res = await this.httpService.post<IApiResponse<IShopifySettings>>('/rms-api/integrations/shopify-settings', data);
        return res.payload;
    }

    async validateCustomReturnPortalUrl(data: IShopifySettings): Promise<ICustomPortalUrlValidationResponse> {
        const res = await this.httpService.post<IApiResponse<ICustomPortalUrlValidationResponse>>('/rms-api/integrations/shopify-settings/validate-custom-return-portal-url', data);
        return res.payload;
    }
}

export default ShopifySettingsService;
